module.exports = __webpack_public_path__ + "img/message_2.d1749620.png";